<template>
  <div id="contenedor-switch-documento-aplica">
    <v-form v-model="esformularioValido" ref="documentoAplica">
      <v-row justify="center">
        <v-switch v-model="expediente.aplica" @change="documentoAplica" inset> </v-switch>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import mixExpedientes from '../mixExpedientes';

export default {
  name: 'SwitchDocumentoAplica',
  mixins: [mixExpedientes],
  props: {
    expedienteDocumentoEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      esformularioValido: false,
      expediente: {
        aplica: this.expedienteDocumentoEditar.aplica,
      },
    };
  },
  methods: {
    documentoAplica() {
      this.mixActualizarExpediente();
    },
    cerrar() {
    },
  },

};
</script>

<style>

</style>
